import Vue from 'vue'
import Vuex from 'vuex'
import { stat } from 'fs';

Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        messageDetails:"",  //消息详情
        MessageList:"",   //消息列表
        phoneNum: "",
        wsWbsocket:"" , //全局的wecsocket对象
        identityCard:"",  //身份证
        person: {
            oneChoose: '',    //会员名
            fiveChoose: "",   //个性签名
            twoChoose: "", //生日
            value1: "",  //性别
            nickName: "",     
        },
        userinfo:"", //用户信息
        newslist:[], //卡列表
        cardInformation:"",  //卡信息
        codePath:""    , //二维码路径
        cardNewList:[],
        sharCard:"", //卡共享者
        cardList:"", //交易流水
        imgSrc:"",  //头像路径
        shopName:"" ,  //店铺名称
        selectedCardInfo:"",     // 被选中会员卡的信息
        cardOrderListInfo:"",     // 历史订单的信息
        selectedOrderInfo:"",     // 被选中的订单信息
    },
    mutations: {
        //店铺名称
        shopName(state, shopName){
            state.shopName=shopName
        },
        //头像路径
        imgSrc(state, imgSrc){
            state.imgSrc=imgSrc
        },
        // 交易流水
        cardList(state, cardList){
            state.cardList=cardList
        },
        // 历史订单的信息
        cardOrderListInfo(state, cardOrderListInfo){
            state.cardOrderListInfo=cardOrderListInfo
        },
        // 被选中的订单信息
        selectedOrderInfo(state, selectedOrderInfo){
            state.selectedOrderInfo=selectedOrderInfo
        },
        sharCard(state, sharCard){
            state.sharCard=sharCard
        },
        selectedCardInfo(state, selectedCardInfo){
            state.selectedCardInfo=selectedCardInfo
        },
        cardNewList(state, cardNewList){
            state.cardNewList=cardNewList
        },
        codePath(state, codePath){
            state.codePath=codePath
        },
        //卡信息
        cardInformation(state, cardInformation){
            state.cardInformation=cardInformation
        },
        // 消息详情
        messageDetails(state, messageDetails){
            state.messageDetails=messageDetails
        },
        //消息列表
        MessageList(state, MessageList){
            state.MessageList=MessageList
        },
        // 用户信息
        userinfo(state, userinfo){
            state.userinfo=userinfo
        },
        // 存储卡列表
        newslist(state, newslist){
            state.newslist=newslist
        },
        SET_PERSON(state, { numId, oneChoose, fiveChoose, twoChoose }) {
            // numberId: this.$store.state.person.numId 
            if (numId) state.person.numId = numId;
            if (oneChoose) state.person.oneChoose = oneChoose;
            if (fiveChoose) state.person.fiveChoose = fiveChoose;
            if (twoChoose) state.person.twoChoose = twoChoose;
        },
        changeValue(state, value) {
            state.person.fiveChoose = value;
        },
        // changeDate(state, date) {
        //     state.person.twoChoose = date;
        //     // alert(1)
        //     console.log(date)
        // },
        changeBirthday(state, value) {
            state.person.twoChoose = value;
        },
        changeGender(state, value) {
            state.person.value1 = value
        },
        chnageNick(state, value) {
            alert(value)
            state.person.nickName = value
        },
        phone(state, phoneNum) {
            state.phoneNum = phoneNum
        },
        getWebsocket(state,wsWbsocket){
            state.wsWbsocket=wsWbsocket
        },
        getIdentity(state,identityCard){
            state.identityCard=identityCard
        },
    }
})

export default store


// WEBPACK FOOTER //
// ./src/vuex/store.js